import useSelector from '@hooks/useSelector'

import {
  Box, DashboardModuleListItem,
} from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import useInvoice from '@hooks/useInvoice'
import { generateUrls } from '@hooks/useUser'

type InvoicePayloadProps = {
  invoicePayload: ReturnType<typeof useInvoice>,
}

const LinkedStaff = (props: InvoicePayloadProps) => {
  const { invoicePayload } = props

  const { leadAgentUserId, supportTeamUserIds, supportTeamUserRoles } = invoicePayload

  const { users } = useSelector(reduxState => reduxState.entities)
  const leadAgentUser = users[leadAgentUserId]

  const { full_name, mobile_number } = leadAgentUser || {}

  const { editUserUrl: leadAgentUserUrl } = generateUrls(leadAgentUser)

  return (
    <Box flexDirection="column">
      {leadAgentUser && (
        <DashboardModuleListItem
          secondaryText={mobile_number}
          title="Agent"
          boxProps={{
            borderBottom: '1px solid',
          }}
        >
          {/*
           // @ts-expect-error TS2339 */}
          <DashboardModuleListItem.TertiaryText>
            {full_name}
            {/*
           // @ts-expect-error TS2339 */}
          </DashboardModuleListItem.TertiaryText>

          <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
            {/*
             // @ts-expect-error TS2339 */}
            <DashboardModuleListItem.Actions>
              {/*
               // @ts-expect-error TS2339 */}
              <DashboardModuleListItem.Icon
                href={`${leadAgentUserUrl}?redirect=${generateRedirectUrl()}`}
                type="link"
              />
              {/*
             // @ts-expect-error TS2339 */}
            </DashboardModuleListItem.Actions>
          </ScopedConditionalContent>
        </DashboardModuleListItem>
      )}

      {supportTeamUserIds.map((userId: number) => {
        const user = users[userId] || {}
        const role = Object.keys(supportTeamUserRoles).find(key => supportTeamUserRoles[key] === userId)

        const { editUserUrl } = generateUrls(user)

        return !!user.id && (
          <DashboardModuleListItem key={user.id} title={role}>
            {/*
             // @ts-expect-error TS2339 */}
            <DashboardModuleListItem.TertiaryText>
              {user.full_name}
              {/*
             // @ts-expect-error TS2339 */}
            </DashboardModuleListItem.TertiaryText>

            <ScopedConditionalContent permittedRoleTitles={['Admin', 'Support']}>
              {/*
               // @ts-expect-error TS2339 */}
              <DashboardModuleListItem.Actions>
                {/*
                 // @ts-expect-error TS2339 */}
                <DashboardModuleListItem.Icon
                  href={`${editUserUrl}?redirect=${generateRedirectUrl()}`}
                  type="link"
                />
                {/*
               // @ts-expect-error TS2339 */}
              </DashboardModuleListItem.Actions>
            </ScopedConditionalContent>
          </DashboardModuleListItem>
        )
      })}
    </Box>
  )
}
export default LinkedStaff
